var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"calc(100vh - 130px)"}},[_c('table-template',{attrs:{"treeProps":{children: 'list',hasChildren: 'hasChildren'},"table_data":_vm.table_data},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-link',{attrs:{"underline":false,"type":"danger"}},[_vm._v("删除")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }